import Model, { Expose } from '@/models/Model';
import Stall from '@/models/Stall';

export default class Vehicle extends Model {
	@Expose public color: null | string = null;
	public customer: number = 0;
	public deleted: boolean = false;
	@Expose public license: null | string = null;
	@Expose public make: null | string = null;
	@Expose public model: null | string = null;
	public notes: null | string = null;
	public other_id: null | string = null;
	@Expose public state: null | string = null;
	public timestamp: Date | string = new Date();
	public type: null | string = null;
	public vehicle: number = 0;
	public vin: null | string = null;
	public year: null | number | string = null;
	public stall: Stall[] = [];


	public constructor(data: any = {}) {
		super();
		this.initialize(data);
	}
}
